import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenaiComponent } from './simple-icons-openai.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenaiComponent ],
    exports:      [ SimpleIconsOpenaiComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenaiModule {}
